module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAARCAYAAAA7bUf6AAABMklEQVQ4T62STStFYRSFn0W+w9gIKRMj/8FfMCCKut2JuvN7L0qUIgMDJr5KCWXKzMjElH9goqRMiCiOdu3B7nTv6VXeOp1z2qtnr/XuLf7hKMuyceAS6C3gfQN1STuNNAapANsJhq4lTTSDzAOHCZBTSdPNIHPAkRefgGegBfgBeoAhQMCFpMkUyCxwHiCDwB3QDewDy8CoN8isJunV7iQ6eQM+vbOJWoF+/68C7cBKcLMraSEP+QpdLIKdDocsAjal9QA5kzSVh5SAqyAaAG48zpK73Aj1A0mlPMSiWAx7zIm9O/07GfIBvAdAG9DnnZMhjaZzD3QByZBH4CWM2KKM/DVO0eIWOrEIxwlrX/PpbAXtnqRyfjpFrFWHrAXRiaQZg9wCYwlOHnwRh4PW7nDzF4srhXNjAbPIAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon-company.png
// module id = 1JdU
// module chunks = 0